/* DO NOT EDIT MANUALLY - this file is generated by GraphQL Code Generator */
/* eslint-disable */

export interface PossibleTypesResultData {
  possibleTypes: {
    [key: string]: string[];
  };
}
const result: PossibleTypesResultData = {
  possibleTypes: {
    Tag: ['ImportedTag', 'SystemTag'],
  },
};
export default result;
